export default __webpack_public_path__ + "static/media/affiliate.833d0552.svg";